import { CreateTagModal as SharedCreateTagModal, type TagFormValues } from "@/components/ui/create-tag-modal";
import { useTags } from "../hooks/use-tags";
import { useOnboardingStore } from "@/modules/onboarding/stores/onboarding-store";

interface CreateTagModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSuccess: (newTagId: string) => void;
	workspaceId: string;
	initialLabel?: string;
}

export function CreateTagModal({ open, onOpenChange, onSuccess, workspaceId, initialLabel }: CreateTagModalProps) {
	const { createTag } = useTags();

	const handleSubmit = async (data: TagFormValues) => {
		const result = await createTag(workspaceId, data);
		if (!result || !result.data) {
			throw new Error("Failed to create tag. Please try again.");
		}
		return result.data.id;
	};

	const handleSuccess = (newTagId?: string) => {
		if (newTagId) {
			useOnboardingStore.getState().completeStep(workspaceId, "setup_tags");
			onSuccess(newTagId);
		}
	};

	return <SharedCreateTagModal open={open} onOpenChange={onOpenChange} onSuccess={handleSuccess} onSubmit={handleSubmit} initialLabel={initialLabel} />;
}
